import React, { useState, useEffect } from "react";
import BillInformation from "../../Components/Payment/BillInformation";
import { connect } from "react-redux";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { getBillStatus } from "../Payment/Payment";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const BillInfoPage = ({ billInfo, token, isLogin }) => {
  const [btnActive, setBtnActive] = useState(true);
  const [windowFocused, setWindowFocused] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState();
  const History = useHistory();
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      History.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          History.push("/rotate");
        }
      },
      false
    );
  }, []);
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      History.push("/addtohome");
    } else if (!isLogin) {
      History.push("/login");
    }
  }, []);
  function handleActivity(forcedFlag) {
    if (typeof forcedFlag === "boolean") {
      return forcedFlag ? setWindowFocused(true) : setWindowFocused(false);
    }

    return document.hidden ? setWindowFocused(false) : setWindowFocused(true);
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    isLogin && getBillStatus(billInfo.id, token, setPaymentStatus);
    if (paymentStatus === 1 && windowFocused) {
      toast.success("پرداخت قبض با موفقیت انجام شد", {
        position: "top-center",
      });

      setBtnActive(true);
    }
  }, [windowFocused, token, paymentStatus]);
  useEffect(() => {
    document.addEventListener("visibilitychange", handleActivity);
    return () => {
      document.removeEventListener("visibilitychange", handleActivity);
    };
  });
  console.log(billInfo);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          paddingBottom: window.innerHeight * 0.1,
          height: "auto",
        }}
      >
        <PhoneHeader text={"جزئیات قبض"} />
        <BillInformation
          date={billInfo.date}
          billId={billInfo.bill_id}
          paymentType={billInfo.paymentType ? billInfo.paymentType : "NULL"}
          payId={billInfo.id}
          billParam={billInfo.parameter}
          billName={
            billInfo.info &&
            (billInfo.info.CustomerName || billInfo.info.OwnerName)
          }
          companyId={billInfo.bill_company_id}
          amount={billInfo.amount}
          info={billInfo.info}
          header={"header"}
          token={token}
          btnActive={btnActive}
          setBtnActive={setBtnActive}
          paymentStatus={billInfo.payment_status}
          period={billInfo.end_of_period}
          paymentParam={billInfo.pay_id}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    billInfo: state.auth.billInfo,
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(BillInfoPage);
